
import { useState } from 'react';

const Gallery = () => {
  const [currentImage, setCurrentImage] = useState(0);
  
  const images = [
    {
      url: 'https://static.readdy.ai/image/a613879414bb29b90c6692df9059d49e/8c54fa344fddfd3b951e14d58d8339b8.png',
      title: 'Senderismo en el Páramo',
      description: 'Explorando los senderos únicos de Mongua'
    },
    {
      url: 'https://static.readdy.ai/image/a613879414bb29b90c6692df9059d49e/51403b2c8808c8cb41b5292a7984f2ad.png',
      title: 'Avistamiento de Colibríes',
      description: 'La increíble fauna del páramo boyacense'
    },
    {
      url: 'https://public.readdy.ai/ai/img_res/3c7211c6da162f1ce78894f4ecc9d6c9.jpg',
      title: 'Camping Bajo las Estrellas',
      description: 'Noches mágicas en contacto con la naturaleza'
    },
    {
      url: 'https://static.readdy.ai/image/a613879414bb29b90c6692df9059d49e/598e3f1a931abf1a8ed4798c39b63972.png',
      title: 'Paisajes del Páramo',
      description: 'La belleza natural de Boyacá'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Tourist%20group%20learning%20about%20native%20plants%20from%20local%20guide%20in%20Colombian%20paramo%2C%20educational%20eco-tourism%2C%20people%20examining%20frailejones%20and%20other%20endemic%20flora%2C%20sustainable%20tourism%20experience&width=800&height=600&seq=gallery5&orientation=landscape',
      title: 'Educación Ambiental',
      description: 'Aprendiendo sobre el ecosistema del páramo'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Photographer%20capturing%20sunrise%20over%20Colombian%20paramo%20landscape%2C%20professional%20camera%20equipment%2C%20golden%20hour%20lighting%2C%20misty%20mountains%2C%20nature%20photography%20workshop%2C%20tourism%20activity&width=800&height=600&seq=gallery6&orientation=landscape',
      title: 'Tours Fotográficos',
      description: 'Capturando la esencia del páramo'
    }
  ];

  const nextImage = () => {
    setCurrentImage((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImage((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-green-800 mb-6" style={{ fontFamily: 'Pacifico, serif' }}>
            Galería de Aventuras
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Revive los momentos más especiales de nuestros tours y descubre la belleza natural que te espera en cada expedición por el páramo de Ocetá.
          </p>
        </div>

        {/* Carrusel principal */}
        <div className="relative mb-12">
          <div className="relative h-96 md:h-[500px] rounded-2xl overflow-hidden shadow-2xl">
            <img 
              src={images[currentImage].url}
              alt={images[currentImage].title}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            
            {/* Información de la imagen */}
            <div className="absolute bottom-8 left-8 text-white">
              <h3 className="text-2xl md:text-3xl font-bold mb-2" style={{ fontFamily: 'Pacifico, serif' }}>
                {images[currentImage].title}
              </h3>
              <p className="text-lg opacity-90">
                {images[currentImage].description}
              </p>
            </div>

            {/* Controles de navegación */}
            <button 
              onClick={prevImage}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white transition-all duration-300 cursor-pointer"
            >
              <i className="ri-arrow-left-line text-xl"></i>
            </button>
            <button 
              onClick={nextImage}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white transition-all duration-300 cursor-pointer"
            >
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
          </div>

          {/* Indicadores */}
          <div className="flex justify-center mt-6 space-x-2">
            {images.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentImage(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
                  index === currentImage ? 'bg-green-600' : 'bg-gray-300 hover:bg-gray-400'
                }`}
              />
            ))}
          </div>
        </div>

        {/* Galería de miniaturas */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {images.map((image, index) => (
            <div 
              key={index}
              onClick={() => setCurrentImage(index)}
              className={`relative h-24 md:h-32 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 ${
                index === currentImage ? 'ring-4 ring-green-600 scale-105' : 'hover:scale-105'
              }`}
            >
              <img 
                src={image.url}
                alt={image.title}
                className="w-full h-full object-cover object-top"
              />
              <div className={`absolute inset-0 transition-all duration-300 ${
                index === currentImage ? 'bg-green-600/20' : 'bg-black/20 hover:bg-black/10'
              }`}></div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a 
            href="https://www.facebook.com/people/Ecoffetours/100063618908701/?sk=photos"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-green-600 hover:bg-green-7  text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-facebook-fill mr-2"></i>
            Ver Más en Facebook
          </a>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
